import * as React from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import { Divider } from "@mui/material";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "#1e3b6e",
    color: theme.palette.common.white,
    fontSize: "0.9rem",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function CustomTable({
  columns,
  rows,
  setSelectedRowData,
  pagination,
  isSearch,
}) {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  React.useEffect(() => {
    setPage(0);
  }, [isSearch, pagination]);

  return (
    <div style={{ width: "100%", overflowX: "auto" }}>
      <TableContainer component={Paper}>
        <Table aria-label="customized table">
          <TableHead>
            <TableRow>
              {columns?.map((heading, index) => {
                return (
                  <StyledTableCell
                    key={index}
                    align={heading !== "Picture" ? "center" : "left"}
                  >
                    {heading}
                  </StyledTableCell>
                );
              })}
            </TableRow>
          </TableHead>

          <TableBody>
            {rows?.length > 0 &&
              rows
                ?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => (
                  <StyledTableRow key={index}>
                    {Object.keys(row).map((key) => (
                      <React.Fragment key={key}>
                        {key !== "id" && (
                          <StyledTableCell
                            onClick={() =>
                              setSelectedRowData && setSelectedRowData(row)
                            }
                            align="center"
                          >
                            {row[key]}
                          </StyledTableCell>
                        )}
                      </React.Fragment>
                    ))}
                  </StyledTableRow>
                ))}
          </TableBody>
        </Table>
        <Divider sx={{ marginTop: 1 }} />
        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          component="div"
          count={rows ? rows.length : 0}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </TableContainer>
    </div>
  );
}
